const gtmConfig = {
  id: 'GTM-N9JDKCVW',
};
export default gtmConfig;
